import authInitializer from "src/modules/auth/authInitializer";

const exportedObject = [authInitializer];

export default exportedObject;
